import {
  faHome,
  faUserShield,
  faFileInvoiceDollar,
  faCommentDots,
  faUserCog,
  faChartPie,
  faColumns,
} from '@fortawesome/free-solid-svg-icons';

export const menuItems = [
  {
    key: 'home',
    icon: faHome,
    title: 'Dashboard',
    route: '/',
    accessKey: null,
  },
  {
    key: 'admin',
    icon: faUserShield,
    title: 'Admin',
    subMenuKey: 'adminSubOpen',
    subItems: [
      {
        key: 'userAccess',
        title: 'User Access',
        route: '/userAccess',
        accessKey: 'userAccess',
      },
      {
        key: 'moduleAccess',
        title: 'Module Access',
        route: '/moduleAccess',
        accessKey: 'moduleAccess',
      },
      {
        key: 'modules',
        title: 'Modules',
        route: '/modules',
        accessKey: 'modules',
      },
      {
        key: 'newAnnouncement',
        title: 'New Announcements',
        route: '/newAnnouncement',
        accessKey: 'newAnnouncement',
      },
    ],
  },
  {
    key: 'service',
    icon: faFileInvoiceDollar,
    title: 'Service',
    subMenuKey: 'serviceSubOpen',
    subItems: [
      {
        key: 'costReportingUpload',
        title: 'Cost Report File Upload',
        route: '/costReportingUpload',
        accessKey: 'costReportingUpload',
      },
      {
        key: 'awsAzureImage',
        title: 'Azure / AWS Image Upload',
        route: '/aWSAzureImageUpload',
        accessKey: 'aWSAzureImageUpload',
      },
      {
        key: 'productRegionReport',
        title: 'Product and Region Report Download',
        route: '/productRegionReport',
        accessKey: 'productRegionReport',
      },
    ],
  },
  {
    key: 'feedback',
    icon: faCommentDots,
    title: 'Feedback',
    route: '/feedback',
    accessKey: 'feedback',
  },
  {
    key: 'userManagement',
    icon: faUserCog,
    title: 'User Management',
    subMenuKey: 'userManagmentSubOpen',
    subItems: [
      {
        key: 'employeeTraining',
        title: 'Employee Training',
        route: '/employeeTraining',
        accessKey: 'employeeTraining',
      },
      {
        key: 'arcusVisitors',
        title: 'Arcus Visitors History',
        route: '/arcusVisitor',
        accessKey: 'arcusVisitor',
      },
      {
        key: 'productandServiceMetrics',
        title: 'Product and Service Metrics',
        route: '/productandServiceMetrics',
        accessKey: 'productandServiceMetrics',
      },
    ],
  },
  {
    key: 'awsskillbuildermetrics',
    icon: faColumns,
    title: 'AWS Skill Builder',
    route: '/awsskillbuildermetrics',
    accessKey: 'awsskillbuildermetrics',
  },
  {
    key: 'servicetrendingtool',
    icon: faChartPie,
    title: 'Service Trending Tool',
    route: '/servicetrendingtool',
    accessKey: 'serviceTrendingTool',
    conditionalRoute: true,
    fallbackRoute: '/accessDenied',
  },
];

export const subMenuStateMap = {
  admin: 'adminSubOpen',
  service: 'serviceSubOpen',
  userManagement: 'userManagmentSubOpen',
};
